import { Flex, Text } from "@chakra-ui/react";
import { t } from "i18next";

export function BrowseEmptyState() {
  return (
    <Flex direction="column" align="center" gap="24px" p="24px" w="full">
      <Text
        fontFamily="Bricolage Grotesque"
        fontSize="20px"
        letterSpacing=".5px"
        fontWeight="700"
        color="dune.dune"
      >
        {t("screens.search.noResultsFound")}
      </Text>
    </Flex>
  );
}
